"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    for (const gamut of ['rec2020', 'p3', 'srgb']) {
        if (matchMedia(`(color-gamut: ${gamut})`).matches) {
            return gamut;
        }
    }
    return "none";
}
exports.default = default_1;
